import { mapGetters } from 'vuex'

import {
  isTeamLeader,
  isTeamMember,
  isVendor,
  roleName,
  redmineUser
} from './definition'

import {
  USER,
  ACCESS_GROUPS
} from 'src/store/definition'

const checkRole = (getters, { accessRole }) => {
  return getters[ACCESS_GROUPS].reduce((accessModels, accessGroup) => {
    accessModels.push(...accessGroup.accessModelList)
    return accessModels
  }, []).some(accessModel => {
    return accessModel.accessRole === accessRole &&
           accessModel.accessModule === 'SOURCING_WF' &&
           accessModel.accessFunction === 'SERVICE_REQUEST'
  })
}

export default {
  [isTeamLeader] (state, getters) {
    return checkRole(getters, {
      accessRole: 'APPROVER'
    })
  },
  [isTeamMember] (state, getters) {
    return checkRole(getters, {
      accessRole: 'EDITOR'
    })
  },
  [isVendor] (state, getters) {
    return checkRole(getters, {
      accessRole: 'CREATOR'
    })
  },
  [roleName] (state, getters) {
    return getters[isTeamLeader] ? 'Team Leader' : getters[isTeamMember] ? 'Team Member' : getters[isVendor] ? 'Vendor' : ''
  },
  [redmineUser] (state, getters) {
    return state.redmineUser
  }
}

export const getters = mapGetters({
  user: USER,
  isTeamLeader,
  isTeamMember,
  isVendor,
  roleName
})



// WEBPACK FOOTER //
// ./src/components/sourcing-workflow/service-request/store/getters.js